module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_orange_04-4ac2dd12be4f2751b757052b029def3a.svg";